module.exports = __webpack_public_path__ + "static/personal1-2c6c487f1d2716542768ae4063c5e94a.jpg";